/**
 * Endless Grinder — Floating Reel PIP Widget
 * Zero-dependency Instagram-style floating video player.
 *
 * Configure via window.EG_FLOATING_REEL before or after this script loads.
 * Default username branding: endlessgrinder
 */
(function () {
  'use strict';

  if (window.__EG_FLOATING_REEL_LOADED__) return;
  window.__EG_FLOATING_REEL_LOADED__ = true;

  var STORAGE_CLOSED = 'eg_floating_reel_closed';
  var STORAGE_MUTED = 'eg_floating_reel_muted';
  var STORAGE_VOLUME = 'eg_floating_reel_volume';
  var STORAGE_SIZE = 'eg_floating_reel_size';
  var STORAGE_CONFIG = 'eg_floating_reel_config';
  var DEFAULTS = {
    position: 'bottom-left', // bottom-left | bottom-right
    width: 160,
    widthMobile: 120,
    widths: [140, 180, 240],
    widthsMobile: [120, 150, 180],
    offsetX: 16,
    offsetY: 16,
    borderColor: '#ffffff',
    borderWidth: 2,
    borderRadius: 0,
    shadow: '0 8px 32px rgba(0,0,0,0.14)',
    // Endless site match: white frame, soft shadow, black CTA
    zIndex: 99999,
    autoplay: true,
    loop: true, // single-video loop; playlist advances on end when >1
    startMuted: true,
    hideControlsUntilHover: true,
    controlsHideDelayMs: 1800,
    showCta: true,
    showEnlarge: true,
    showVolumeSlider: true,
    defaultVolume: 0.7,
    delayMs: 800,
    hideOnPaths: [],
    username: 'endlessgrinder',
    clickToTogglePlay: true,
    autoAdvance: true,
    videos: [],
    // Instagram fallbacks
    instagramPermalink: '',
    instagramEmbedUrl: '',
    // Optional Graph API (needs Meta token)
    accessToken: '',
    userId: '',
    graphLimit: 3,
  };

  function mergeConfig(base, over) {
    var out = {};
    var k;
    for (k in base) if (Object.prototype.hasOwnProperty.call(base, k)) out[k] = base[k];
    if (over) for (k in over) if (Object.prototype.hasOwnProperty.call(over, k)) out[k] = over[k];
    return out;
  }

  function readStoredConfig() {
    try {
      var raw = localStorage.getItem(STORAGE_CONFIG);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') return parsed;
    } catch (e) {}
    return null;
  }

  function cfg() {
    // Priority: DEFAULTS < window.EG_FLOATING_REEL < localStorage (admin editor wins)
    var merged = mergeConfig(DEFAULTS, window.EG_FLOATING_REEL || {});
    var stored = readStoredConfig();
    if (stored) merged = mergeConfig(merged, stored);
    return merged;
  }

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 640px)').matches;
  }

  function pathHidden(c) {
    var path = (location.pathname || '/').replace(/\/$/, '') || '/';
    var list = c.hideOnPaths || [];
    for (var i = 0; i < list.length; i++) {
      var p = String(list[i]).replace(/\/$/, '') || '/';
      if (p === path) return true;
    }
    return false;
  }

  function sessionClosed() {
    try {
      return sessionStorage.getItem(STORAGE_CLOSED) === '1';
    } catch (e) {
      return false;
    }
  }

  function setSessionClosed() {
    try {
      sessionStorage.setItem(STORAGE_CLOSED, '1');
    } catch (e) {}
  }

  function getMutedPref(c) {
    try {
      var v = localStorage.getItem(STORAGE_MUTED);
      if (v === '0') return false;
      if (v === '1') return true;
    } catch (e) {}
    return !!c.startMuted;
  }

  function setMutedPref(muted) {
    try {
      localStorage.setItem(STORAGE_MUTED, muted ? '1' : '0');
    } catch (e) {}
  }

  function getVolumePref(c) {
    try {
      var v = localStorage.getItem(STORAGE_VOLUME);
      if (v != null && v !== '') {
        var n = parseFloat(v);
        if (!isNaN(n) && n >= 0 && n <= 1) return n;
      }
    } catch (e) {}
    var d = c.defaultVolume != null ? Number(c.defaultVolume) : 0.7;
    if (isNaN(d)) d = 0.7;
    return Math.max(0, Math.min(1, d));
  }

  function setVolumePref(vol) {
    try {
      localStorage.setItem(STORAGE_VOLUME, String(vol));
    } catch (e) {}
  }

  function getSizeIndex() {
    try {
      var v = sessionStorage.getItem(STORAGE_SIZE);
      if (v != null && v !== '') {
        var n = parseInt(v, 10);
        if (!isNaN(n) && n >= 0) return n;
      }
    } catch (e) {}
    return 0;
  }

  function setSizeIndex(idx) {
    try {
      sessionStorage.setItem(STORAGE_SIZE, String(idx));
    } catch (e) {}
  }

  function getWidthsList(c) {
    var mobile = isMobile();
    if (mobile) {
      if (Array.isArray(c.widthsMobile) && c.widthsMobile.length) return c.widthsMobile;
      if (Array.isArray(c.widths) && c.widths.length) {
        var base = c.width || c.widths[0] || 160;
        var mw = c.widthMobile || 120;
        var scale = base > 0 ? mw / base : 0.75;
        return c.widths.map(function (w) {
          return Math.round(Number(w) * scale);
        });
      }
      return [c.widthMobile || 120];
    }
    if (Array.isArray(c.widths) && c.widths.length) return c.widths;
    return [c.width || 160];
  }

  function reelCodeFromUrl(url) {
    if (!url) return '';
    var m = String(url).match(/instagram\.com\/(?:reel|reels|p)\/([A-Za-z0-9_-]+)/);
    return m ? m[1] : '';
  }

  function embedUrlFromPermalink(permalink, embedUrl) {
    if (embedUrl) return embedUrl;
    var code = reelCodeFromUrl(permalink);
    if (code) return 'https://www.instagram.com/reel/' + code + '/embed';
    return '';
  }

  function injectStyles() {
    var oldCss = document.getElementById('eg-floating-reel-css');
    if (oldCss) oldCss.parentNode.removeChild(oldCss);
    var css =
      '#eg-floating-reel{box-sizing:border-box;position:fixed;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;line-height:1;user-select:none;-webkit-tap-highlight-color:transparent}' +
      '#eg-floating-reel *,#eg-floating-reel *::before,#eg-floating-reel *::after{box-sizing:border-box}' +
      '#eg-floating-reel .eg-fr-shell{position:relative;width:100%;height:100%;overflow:hidden;background:#111;border-radius:0;transition:width .25s ease,height .25s ease}' +
      '#eg-floating-reel .eg-fr-media{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;background:#000;cursor:pointer}' +
      '#eg-floating-reel .eg-fr-iframe{position:absolute;inset:0;width:100%;height:100%;border:0;background:#000}' +
      '#eg-floating-reel .eg-fr-controls{position:absolute;inset:0;pointer-events:none;z-index:5}' +
      '#eg-floating-reel .eg-fr-bar{position:absolute;top:8px;left:8px;right:8px;display:flex;flex-direction:row;justify-content:space-between;align-items:flex-start;gap:6px;pointer-events:none;z-index:6}' +
      '#eg-floating-reel .eg-fr-btn{pointer-events:auto;appearance:none!important;-webkit-appearance:none!important;border:0;outline:0;cursor:pointer;display:inline-flex!important;align-items:center;justify-content:center;width:28px!important;min-width:28px!important;max-width:28px!important;height:28px!important;min-height:28px!important;border-radius:0!important;background:rgba(0,0,0,.55)!important;color:#fff!important;border:1px solid rgba(255,255,255,.35)!important;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);transition:background .15s ease;padding:0!important;margin:0!important;flex:0 0 28px!important;line-height:1!important;float:none!important;position:relative!important}' +
      '#eg-floating-reel .eg-fr-btn:hover{background:rgba(0,0,0,.75)!important}' +
      '#eg-floating-reel .eg-fr-btn svg{width:14px!important;height:14px!important;display:block;fill:currentColor;pointer-events:none}' +
      '#eg-floating-reel .eg-fr-top-left{position:relative!important;display:flex!important;flex-direction:column;align-items:flex-start;gap:4px;pointer-events:auto;flex:0 1 auto;max-width:40%!important;min-width:0}' +
      '#eg-floating-reel .eg-fr-top-right{position:static!important;display:flex!important;flex-direction:row;flex-wrap:nowrap;align-items:center;gap:4px;pointer-events:auto;flex:0 0 auto;flex-shrink:0!important;margin-left:auto}' +
      '#eg-floating-reel .eg-fr-top-left,#eg-floating-reel .eg-fr-top-right{align-items:center!important;height:28px!important}' +
      '#eg-floating-reel .eg-fr-vol-wrap{position:relative!important;display:flex!important;flex-direction:row;align-items:center;justify-content:flex-start;gap:4px;padding:0!important;margin:0!important;background:transparent!important;border:0!important;border-radius:0;height:28px!important;max-width:100%;width:auto!important;box-sizing:border-box!important}' +
      '#eg-floating-reel .eg-fr-vol-wrap .eg-fr-btn{width:28px!important;min-width:28px!important;max-width:28px!important;height:28px!important;min-height:28px!important;flex:0 0 28px!important;border:1px solid rgba(255,255,255,.35)!important;background:rgba(0,0,0,.55)!important}' +
      '#eg-floating-reel .eg-fr-vol-chevron{width:28px!important;min-width:28px!important;max-width:28px!important;height:28px!important;min-height:28px!important;flex:0 0 28px!important;padding:0!important;margin:0!important;border:1px solid rgba(255,255,255,.35)!important;border-radius:0!important;background:rgba(0,0,0,.55)!important;color:#fff!important;cursor:pointer;pointer-events:auto;display:none!important;align-items:center;justify-content:center;appearance:none!important;-webkit-appearance:none!important;box-sizing:border-box!important}' +
      '#eg-floating-reel .eg-fr-vol-chevron svg{width:12px!important;height:12px!important;fill:currentColor;display:block;pointer-events:none}' +
      '#eg-floating-reel .eg-fr-vol-panel{display:none;position:absolute;left:0;top:100%;margin-top:4px;z-index:10;padding:6px 8px;background:rgba(0,0,0,.75);border:1px solid rgba(255,255,255,.3);border-radius:0;width:auto!important;max-width:none!important;height:auto!important;box-shadow:0 4px 12px rgba(0,0,0,.35)}' +
      '#eg-floating-reel .eg-fr-vol-wrap.is-vol-open .eg-fr-vol-panel{display:block!important}' +
      '#eg-floating-reel .eg-fr-vol{pointer-events:auto;-webkit-appearance:none!important;appearance:none!important;width:64px!important;min-width:48px!important;max-width:64px!important;height:4px!important;background:#fff!important;border:1px solid #000!important;border-radius:0!important;outline:0;cursor:pointer;padding:0!important;margin:0!important;flex:0 0 auto!important;vertical-align:middle;display:block}' +
      '#eg-floating-reel .eg-fr-vol::-webkit-slider-thumb{-webkit-appearance:none!important;appearance:none!important;width:12px!important;height:12px!important;background:#fff!important;border:2px solid #000!important;border-radius:0!important;cursor:pointer}' +
      '#eg-floating-reel .eg-fr-vol::-moz-range-thumb{width:12px!important;height:12px!important;background:#fff!important;border:2px solid #000!important;border-radius:0!important;cursor:pointer}' +
      '#eg-floating-reel .eg-fr-vol::-moz-range-track{height:4px!important;background:#fff!important;border:1px solid #000!important;border-radius:0!important}' +
      '#eg-floating-reel.eg-size-sm .eg-fr-bar{gap:4px;top:6px;left:6px;right:6px}' +
      '#eg-floating-reel.eg-size-sm .eg-fr-top-left,#eg-floating-reel.eg-size-sm .eg-fr-top-right{height:28px!important}' +
      '#eg-floating-reel.eg-size-sm .eg-fr-btn,#eg-floating-reel.eg-size-sm .eg-fr-vol-wrap .eg-fr-btn,#eg-floating-reel.eg-size-sm .eg-fr-vol-chevron{width:28px!important;min-width:28px!important;max-width:28px!important;height:28px!important;min-height:28px!important;flex:0 0 28px!important}' +
      '#eg-floating-reel.eg-size-sm .eg-fr-btn svg{width:14px!important;height:14px!important}' +
      '#eg-floating-reel.eg-size-sm .eg-fr-top-right{gap:4px}' +
      '#eg-floating-reel.eg-size-sm .eg-fr-vol-wrap{height:28px!important;gap:4px}' +
      '#eg-floating-reel.eg-size-sm .eg-fr-vol-chevron{display:inline-flex!important}' +
      '#eg-floating-reel.eg-size-sm .eg-fr-vol-panel .eg-fr-vol{width:56px!important;max-width:56px!important}' +
      '#eg-floating-reel.eg-size-md .eg-fr-btn,#eg-floating-reel.eg-size-md .eg-fr-vol-wrap .eg-fr-btn,#eg-floating-reel.eg-size-md .eg-fr-vol-chevron{width:28px!important;min-width:28px!important;max-width:28px!important;height:28px!important;min-height:28px!important;flex:0 0 28px!important}' +
      '#eg-floating-reel.eg-size-md .eg-fr-vol-chevron{display:inline-flex!important}' +
      '#eg-floating-reel.eg-size-md .eg-fr-top-right{gap:4px}' +
      '#eg-floating-reel.eg-size-lg .eg-fr-vol-wrap{flex-wrap:nowrap;height:28px!important;align-items:center!important}' +
      '#eg-floating-reel.eg-size-lg .eg-fr-vol-chevron{display:none!important}' +
      '#eg-floating-reel.eg-size-lg .eg-fr-vol-panel{display:flex!important;align-items:center;position:static!important;margin-top:0!important;padding:0!important;background:transparent!important;border:0!important;box-shadow:none!important;z-index:auto;height:28px!important}' +
      '#eg-floating-reel.eg-size-lg .eg-fr-vol-wrap.is-vol-open .eg-fr-vol-panel{display:flex!important}' +
      '#eg-floating-reel .eg-fr-chrome{position:absolute;inset:0;pointer-events:none;z-index:5;opacity:0;transition:opacity .2s ease}' +'#eg-floating-reel.eg-show-controls .eg-fr-chrome,#eg-floating-reel:hover .eg-fr-chrome,#eg-floating-reel:focus-within .eg-fr-chrome{opacity:1}' +'#eg-floating-reel.eg-always-controls .eg-fr-chrome{opacity:1}' +'#eg-floating-reel .eg-fr-chrome .eg-fr-bar,#eg-floating-reel .eg-fr-chrome .eg-fr-cta,#eg-floating-reel .eg-fr-chrome .eg-fr-nav{pointer-events:auto}' +'#eg-floating-reel:not(.eg-show-controls):not(:hover):not(:focus-within) .eg-fr-chrome .eg-fr-bar,#eg-floating-reel:not(.eg-show-controls):not(:hover):not(:focus-within) .eg-fr-chrome .eg-fr-cta,#eg-floating-reel:not(.eg-show-controls):not(:hover):not(:focus-within) .eg-fr-chrome .eg-fr-nav{pointer-events:none}' +
      '#eg-floating-reel .eg-fr-cta{pointer-events:auto;position:absolute;left:8px;right:8px;bottom:8px;display:flex;align-items:center;justify-content:center;text-align:center;text-decoration:none;color:#fff;background:#000;font-family:inherit;font-size:11px;font-weight:600;letter-spacing:.04em;text-transform:none;padding:9px 12px;border-radius:0;border:1px solid #000;box-shadow:0 2px 8px rgba(0,0,0,.18);transition:transform .15s ease,opacity .15s,background .15s}' +
      '#eg-floating-reel .eg-fr-cta:hover{transform:translateY(-1px);background:#111}' +
      '#eg-floating-reel .eg-fr-nav{pointer-events:auto;position:absolute;top:50%;transform:translateY(-50%);width:26px;height:26px;border-radius:0;background:rgba(0,0,0,.4);color:#fff;border:1px solid rgba(255,255,255,.25);cursor:pointer;display:none!important;align-items:center;justify-content:center;padding:0}' +
      '#eg-floating-reel.has-playlist .eg-fr-nav{display:inline-flex!important}' +
      '#eg-floating-reel .eg-fr-prev{left:4px}' +
      '#eg-floating-reel .eg-fr-next{right:4px}' +
      '#eg-floating-reel .eg-fr-nav svg{width:12px;height:12px;fill:currentColor}' +
      '#eg-floating-reel.is-minimized{width:56px!important;height:56px!important}' +
      '#eg-floating-reel.is-minimized .eg-fr-shell{border-radius:0!important;cursor:pointer}' +
      '#eg-floating-reel.is-minimized .eg-fr-controls,' +
      '#eg-floating-reel.is-minimized .eg-fr-cta,' +
      '#eg-floating-reel.is-minimized .eg-fr-nav,' +
      '#eg-floating-reel.is-minimized .eg-fr-iframe{display:none!important}' +
      '#eg-floating-reel.is-minimized .eg-fr-media{cursor:pointer}' +
      '#eg-floating-reel .eg-fr-mini-play{display:none;position:absolute;inset:0;align-items:center;justify-content:center;background:rgba(0,0,0,.35);z-index:3;pointer-events:none}' +
      '#eg-floating-reel.is-minimized .eg-fr-mini-play{display:flex}' +
      '#eg-floating-reel .eg-fr-mini-play svg{width:22px;height:22px;fill:#fff;filter:drop-shadow(0 1px 3px rgba(0,0,0,.5))}' +
      '#eg-floating-reel.is-hidden{display:none!important}' +
      '@media (prefers-reduced-motion:reduce){#eg-floating-reel .eg-fr-shell{transition:none}}';
    var style = document.createElement('style');
    style.id = 'eg-floating-reel-css';
    style.setAttribute('data-eg-fr-v', '5');
    style.textContent = css;
    document.head.appendChild(style);
  }

  /* Inline SVG icons */
  var ICONS = {
    mute:
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4.3 3.7 3 5l3.2 3.2H3v7.6h3.5L12 21.2V9.8L4.3 3.7zm9.7 3.1v2.2l2 2V8.9c1.2.5 2 1.6 2 2.9 0 .5-.1 1-.3 1.4l1.5 1.5c.5-.8.8-1.8.8-2.9 0-2.6-1.8-4.8-4.2-5.5zM12 3.5l-1.5 1.5 1.5 1.5V3.5zM19.1 19l1.4-1.4-3.2-3.2.1-.1c.4.7.6 1.5.6 2.3 0 .8-.2 1.6-.5 2.3l1.6 1.1z"/></svg>',
    unmute:
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 9.2v5.6h3.5L12 20.4V3.6L6.5 9.2H3zm13 2.8c0-1.3-.8-2.4-2-2.9v5.8c1.2-.5 2-1.6 2-2.9zm-2-7.1v2.1c2.4.7 4.2 2.9 4.2 5.5s-1.8 4.8-4.2 5.5v2.1C18.4 18.5 21 15.1 21 12s-2.6-6.5-7-7.1z"/></svg>',
    min: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 11h14v2H5z"/></svg>',
    close: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18.3 5.7 12 12l6.3 6.3-1.4 1.4L10.6 13.4 4.3 19.7 2.9 18.3 9.2 12 2.9 5.7 4.3 4.3l6.3 6.3 6.3-6.3z"/></svg>',
    play: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>',
    prev: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15.4 7.4 10.8 12l4.6 4.6L14 18l-6-6 6-6z"/></svg>',
    next: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8.6 7.4 13.2 12l-4.6 4.6L10 18l6-6-6-6z"/></svg>',
    expand:
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg>',
    compress:
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"/></svg>',
    chevronDown:
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7.4 8.6 12 13.2l4.6-4.6L18 10l-6 6-6-6z"/></svg>',
  };

  function buildPlaylist(c) {
    var list = [];
    var videos = Array.isArray(c.videos) ? c.videos : [];
    for (var i = 0; i < videos.length; i++) {
      var v = videos[i] || {};
      if (v.src || v.instagramPermalink || v.instagramEmbedUrl) {
        list.push({
          src: v.src || '',
          poster: v.poster || '',
          permalink: v.permalink || v.instagramPermalink || '',
          embedUrl: v.instagramEmbedUrl || embedUrlFromPermalink(v.instagramPermalink || v.permalink || '', ''),
          caption: v.caption || '',
          ctaText: v.ctaText || '',
          ctaUrl: v.ctaUrl || '',
        });
      }
    }
    // Top-level IG permalink as single-item playlist if no videos
    if (!list.length) {
      var emb = embedUrlFromPermalink(c.instagramPermalink, c.instagramEmbedUrl);
      if (emb) {
        list.push({
          src: '',
          poster: '',
          permalink: c.instagramPermalink || '',
          embedUrl: emb,
          caption: '',
          ctaText: '',
          ctaUrl: '',
        });
      }
    }
    return list;
  }

  function fetchGraphMedia(c, done) {
    if (!c.accessToken || !c.userId) {
      done([]);
      return;
    }
    var limit = Math.max(1, Math.min(12, c.graphLimit || 3));
    var url =
      'https://graph.instagram.com/' +
      encodeURIComponent(c.userId) +
      '/media?fields=id,media_type,media_url,thumbnail_url,permalink,caption&limit=' +
      limit +
      '&access_token=' +
      encodeURIComponent(c.accessToken);
    // Also try Facebook Graph host as alternate
    fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('graph ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var items = (data && data.data) || [];
        var out = [];
        for (var i = 0; i < items.length; i++) {
          var m = items[i];
          if (m.media_type === 'VIDEO' || m.media_type === 'REELS') {
            if (m.media_url) {
              out.push({
                src: m.media_url,
                poster: m.thumbnail_url || '',
                permalink: m.permalink || '',
                embedUrl: embedUrlFromPermalink(m.permalink || '', ''),
                caption: m.caption || '',
                ctaText: '',
                ctaUrl: m.permalink || '',
              });
            }
          }
        }
        done(out);
      })
      .catch(function () {
        done([]);
      });
  }

  function destroyWidget() {
    var el = document.getElementById('eg-floating-reel');
    if (el && el.parentNode) el.parentNode.removeChild(el);
    try {
      sessionStorage.removeItem(STORAGE_CLOSED);
    } catch (e) {}
  }

  function remount(options) {
    options = options || {};
    destroyWidget();
    if (options.clearClosed) {
      try {
        sessionStorage.removeItem(STORAGE_CLOSED);
      } catch (e) {}
    }
    var c = cfg();
    if (pathHidden(c)) return;
    var list = buildPlaylist(c);
    if (!list.length) {
      // Still try Graph if token present
      fetchGraphMedia(c, function (remote) {
        if (remote.length) createWidget(remote, c);
      });
      return;
    }
    // Admin / live preview: skip delay unless explicitly kept
    if (options.immediate || options.skipDelay) {
      createWidget(list, c);
    } else {
      var delay = Math.max(0, c.delayMs || 0);
      setTimeout(function () {
        if (sessionClosed()) return;
        if (document.getElementById('eg-floating-reel')) return;
        createWidget(list, c);
      }, delay);
    }
  }

  function createWidget(playlist, c) {
    injectStyles();

    var root = document.createElement('div');
    root.id = 'eg-floating-reel';
    root.setAttribute('role', 'complementary');
    root.setAttribute('aria-label', 'Floating reel video');

    var shell = document.createElement('div');
    shell.className = 'eg-fr-shell';

    var video = document.createElement('video');
    video.className = 'eg-fr-media';
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('preload', 'metadata');
    video.muted = getMutedPref(c);
    video.volume = getVolumePref(c);
    video.loop = !!(c.loop && playlist.length <= 1);
    video.autoplay = !!c.autoplay;
    video.playsInline = true;

    var iframe = document.createElement('iframe');
    iframe.className = 'eg-fr-iframe';
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('title', 'Instagram reel');
    iframe.style.display = 'none';
    // Instagram embed needs scrolling + allow
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture';

    var miniPlay = document.createElement('div');
    miniPlay.className = 'eg-fr-mini-play';
    miniPlay.innerHTML = ICONS.play;

    var controls = document.createElement('div');
    controls.className = 'eg-fr-controls';

    var topLeft = document.createElement('div');
    topLeft.className = 'eg-fr-top-left';
    var muteBtn = document.createElement('button');
    muteBtn.type = 'button';
    muteBtn.className = 'eg-fr-btn eg-fr-mute';
    muteBtn.setAttribute('aria-label', 'Mute');

    var volWrap = null;
    var volSlider = null;
    var volPanel = null;
    var volChevron = null;
    var volPanelOpen = false;
    if (c.showVolumeSlider !== false) {
      volWrap = document.createElement('div');
      volWrap.className = 'eg-fr-vol-wrap';
      volChevron = document.createElement('button');
      volChevron.type = 'button';
      volChevron.className = 'eg-fr-vol-chevron';
      volChevron.setAttribute('aria-label', 'Volume');
      volChevron.innerHTML = ICONS.chevronDown;
      volPanel = document.createElement('div');
      volPanel.className = 'eg-fr-vol-panel';
      volSlider = document.createElement('input');
      volSlider.type = 'range';
      volSlider.className = 'eg-fr-vol';
      volSlider.min = '0';
      volSlider.max = '1';
      volSlider.step = '0.01';
      volSlider.value = String(video.volume);
      volSlider.setAttribute('aria-label', 'Volume');
      volPanel.appendChild(volSlider);
      volWrap.appendChild(muteBtn);
      volWrap.appendChild(volChevron);
      volWrap.appendChild(volPanel);
      topLeft.appendChild(volWrap);
    } else {
      topLeft.appendChild(muteBtn);
    }

    var topRight = document.createElement('div');
    topRight.className = 'eg-fr-top-right';

    var enlargeBtn = null;
    if (c.showEnlarge !== false) {
      enlargeBtn = document.createElement('button');
      enlargeBtn.type = 'button';
      enlargeBtn.className = 'eg-fr-btn eg-fr-enlarge';
      enlargeBtn.setAttribute('aria-label', 'Enlarge');
      enlargeBtn.innerHTML = ICONS.expand;
      topRight.appendChild(enlargeBtn);
    }

    var minBtn = document.createElement('button');
    minBtn.type = 'button';
    minBtn.className = 'eg-fr-btn eg-fr-min';
    minBtn.setAttribute('aria-label', 'Minimize');
    minBtn.innerHTML = ICONS.min;
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'eg-fr-btn eg-fr-close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = ICONS.close;

    topRight.appendChild(minBtn);
    topRight.appendChild(closeBtn);
    var bar = document.createElement('div');
    bar.className = 'eg-fr-bar';
    bar.appendChild(topLeft);
    bar.appendChild(topRight);
    controls.appendChild(bar);

    var chrome = document.createElement('div');
    chrome.className = 'eg-fr-chrome';
    // Move bar into chrome; CTA/nav appended to chrome after creation below
    controls.appendChild(chrome);
    chrome.appendChild(bar);

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'eg-fr-nav eg-fr-prev';
    prevBtn.setAttribute('aria-label', 'Previous');
    prevBtn.innerHTML = ICONS.prev;
    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'eg-fr-nav eg-fr-next';
    nextBtn.setAttribute('aria-label', 'Next');
    nextBtn.innerHTML = ICONS.next;

    var cta = document.createElement('a');
    cta.className = 'eg-fr-cta';
    cta.target = '_blank';
    cta.rel = 'noopener noreferrer';
    cta.style.display = 'none';

    shell.appendChild(video);
    shell.appendChild(iframe);
    shell.appendChild(miniPlay);
    chrome.appendChild(prevBtn);
    chrome.appendChild(nextBtn);
    chrome.appendChild(cta);
    shell.appendChild(controls);
    root.appendChild(shell);
    document.body.appendChild(root);

    // Ensure muted autoplay starts immediately
    video.muted = true;
    setMutedPref(true);
    if (c.autoplay !== false) {
      video.autoplay = true;
      var _bootPlay = video.play();
      if (_bootPlay && _bootPlay.catch) _bootPlay.catch(function () {});
    }

    // Hover / touch: show controls
    var hideTimer = null;
    function showControlsChrome(stickyMs) {
      if (c.hideControlsUntilHover === false) {
        root.classList.add('eg-always-controls');
        return;
      }
      root.classList.add('eg-show-controls');
      if (hideTimer) clearTimeout(hideTimer);
      var delay = stickyMs != null ? stickyMs : (c.controlsHideDelayMs != null ? c.controlsHideDelayMs : 1800);
      if (delay > 0) {
        hideTimer = setTimeout(function () {
          if (!root.matches(':hover') && !root.contains(document.activeElement)) {
            root.classList.remove('eg-show-controls');
          }
        }, delay);
      }
    }
    function hideControlsChrome() {
      if (c.hideControlsUntilHover === false) return;
      if (hideTimer) clearTimeout(hideTimer);
      root.classList.remove('eg-show-controls');
    }
    if (c.hideControlsUntilHover === false) {
      root.classList.add('eg-always-controls');
    } else {
      root.addEventListener('mouseenter', function () { showControlsChrome(0); });
      root.addEventListener('mouseleave', function () { hideControlsChrome(); });
      root.addEventListener('mousemove', function () { showControlsChrome(); });
      // Touch: tap video toggles chrome (don't fight click-to-play too hard)
      var touchShow = false;
      shell.addEventListener('touchstart', function (e) {
        if (e.target.closest && (e.target.closest('.eg-fr-btn') || e.target.closest('.eg-fr-vol') || e.target.closest('.eg-fr-cta') || e.target.closest('.eg-fr-nav'))) {
          showControlsChrome(2500);
          return;
        }
        touchShow = !root.classList.contains('eg-show-controls');
        if (touchShow) showControlsChrome(2500);
        else hideControlsChrome();
      }, { passive: true });
    }

    var index = 0;
    var minimized = false;
    var usingEmbed = false;
    var sizeIndex = getSizeIndex();

    function currentWidth() {
      var list = getWidthsList(c);
      if (!list.length) return isMobile() ? c.widthMobile || 120 : c.width || 160;
      if (sizeIndex >= list.length) sizeIndex = sizeIndex % list.length;
      if (sizeIndex < 0) sizeIndex = 0;
      var w = Number(list[sizeIndex]);
      if (isNaN(w) || w <= 0) w = list[0] || 160;
      return w;
    }

    function updateEnlargeIcon() {
      if (!enlargeBtn) return;
      var list = getWidthsList(c);
      var atMax = list.length <= 1 || sizeIndex >= list.length - 1;
      enlargeBtn.innerHTML = atMax ? ICONS.compress : ICONS.expand;
      enlargeBtn.setAttribute('aria-label', atMax ? 'Shrink' : 'Enlarge');
    }

    function setSizeClass(w) {
      root.classList.remove('eg-size-sm', 'eg-size-md', 'eg-size-lg');
      if (w < 160) root.classList.add('eg-size-sm');
      else if (w < 200) root.classList.add('eg-size-md');
      else root.classList.add('eg-size-lg');
    }

    function setVolPanelOpen(open) {
      volPanelOpen = !!open;
      if (volWrap) {
        if (volPanelOpen) volWrap.classList.add('is-vol-open');
        else volWrap.classList.remove('is-vol-open');
      }
    }

    function syncVolPanelForSize() {
      if (!volWrap) return;
      // On lg, slider is always inline (CSS); keep is-vol-open for consistency
      if (root.classList.contains('eg-size-lg')) {
        setVolPanelOpen(true);
      } else if (!video.muted && !usingEmbed) {
        setVolPanelOpen(true);
      } else if (video.muted) {
        setVolPanelOpen(false);
      }
    }

    function applyLayout() {
      var w = currentWidth();
      // Mobile: clamp so enlarged mode doesn't crush controls on phone
      if (isMobile()) {
        var vwCap = Math.round(window.innerWidth * 0.42);
        w = Math.min(w, vwCap, 180);
      }
      var h = Math.round((w * 16) / 9);
      var ox = c.offsetX != null ? c.offsetX : 16;
      var oy = c.offsetY != null ? c.offsetY : 16;
      var pos = c.position === 'bottom-right' ? 'bottom-right' : 'bottom-left';
      var radius = c.borderRadius != null ? c.borderRadius : 0;

      root.style.zIndex = String(c.zIndex || 99999);
      root.style.bottom = oy + 'px';
      if (pos === 'bottom-right') {
        root.style.right = ox + 'px';
        root.style.left = 'auto';
      } else {
        root.style.left = ox + 'px';
        root.style.right = 'auto';
      }

      if (!minimized) {
        root.style.width = w + 'px';
        root.style.height = h + 'px';
      }

      shell.style.borderRadius = radius + 'px';
      shell.style.border = (c.borderWidth != null ? c.borderWidth : 2) + 'px solid ' + (c.borderColor || '#ffffff');
      shell.style.boxShadow = c.shadow || '0 8px 32px rgba(0,0,0,0.14)';
      cta.style.borderRadius = radius + 'px';

      if (playlist.length > 1) root.classList.add('has-playlist');
      else root.classList.remove('has-playlist');

      setSizeClass(w);
      syncVolPanelForSize();
      updateEnlargeIcon();
    }

    function updateMuteIcon() {
      var muted = usingEmbed ? true : !!video.muted;
      muteBtn.innerHTML = muted ? ICONS.mute : ICONS.unmute;
      muteBtn.setAttribute('aria-label', muted ? 'Unmute' : 'Mute');
      if (volWrap) {
        volWrap.style.display = usingEmbed ? 'none' : '';
      } else {
        muteBtn.style.display = usingEmbed ? 'none' : '';
      }
    }

    function applyVolume(vol, opts) {
      opts = opts || {};
      vol = Math.max(0, Math.min(1, Number(vol)));
      if (isNaN(vol)) vol = 0.7;
      video.volume = vol;
      if (volSlider) volSlider.value = String(vol);
      if (vol > 0 && !opts.keepMuted) {
        video.muted = false;
        setMutedPref(false);
      }
      if (vol === 0 && opts.muteOnZero) {
        video.muted = true;
        setMutedPref(true);
      }
      setVolumePref(vol);
      updateMuteIcon();
    }

    function updateCta(item) {
      if (!c.showCta) {
        cta.style.display = 'none';
        return;
      }
      var text = item.ctaText || '';
      var url = item.ctaUrl || item.permalink || '';
      if (!text && url) text = 'צפו באינסטגרם';
      if (!text || !url) {
        cta.style.display = 'none';
        return;
      }
      cta.textContent = text;
      cta.href = url;
      cta.style.display = '';
    }

    function loadIndex(i) {
      if (!playlist.length) return;
      index = ((i % playlist.length) + playlist.length) % playlist.length;
      var item = playlist[index];

      // Prefer direct src; else Instagram embed
      if (item.src) {
        usingEmbed = false;
        iframe.style.display = 'none';
        iframe.removeAttribute('src');
        video.style.display = '';
        video.poster = item.poster || '';
        video.loop = !!(c.loop && playlist.length <= 1);
        if (video.src !== item.src) {
          video.src = item.src;
          video.load();
        }
        if (c.autoplay && !minimized) {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        }
        if (volWrap) volWrap.style.display = '';
        else muteBtn.style.display = '';
      } else if (item.embedUrl) {
        usingEmbed = true;
        video.pause();
        video.removeAttribute('src');
        video.load();
        video.style.display = 'none';
        iframe.style.display = '';
        if (iframe.src !== item.embedUrl) iframe.src = item.embedUrl;
        if (volWrap) volWrap.style.display = 'none';
        else muteBtn.style.display = 'none';
      }
      updateMuteIcon();
      updateCta(item);
    }

    function minimize() {
      minimized = true;
      root.classList.add('is-minimized');
      applyLayout();
      // Keep playing quietly in bubble if video mode
      if (!usingEmbed && c.autoplay) {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
    }

    function restore() {
      minimized = false;
      root.classList.remove('is-minimized');
      applyLayout();
      if (!usingEmbed && c.autoplay) {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
    }

    function dismiss() {
      setSessionClosed();
      root.classList.add('is-hidden');
      try {
        video.pause();
      } catch (e) {}
      iframe.removeAttribute('src');
    }

    function cycleSize() {
      var list = getWidthsList(c);
      if (list.length <= 1) return;
      sizeIndex = (sizeIndex + 1) % list.length;
      setSizeIndex(sizeIndex);
      applyLayout();
    }

    muteBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (usingEmbed) return;
      video.muted = !video.muted;
      setMutedPref(video.muted);
      updateMuteIcon();
      if (!video.muted) {
        if (video.volume <= 0) {
          applyVolume(getVolumePref(c) || c.defaultVolume || 0.7, { keepMuted: false });
        }
        // Reveal compact volume panel on sm/md when unmuted
        if (!root.classList.contains('eg-size-lg')) setVolPanelOpen(true);
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      } else if (!root.classList.contains('eg-size-lg')) {
        setVolPanelOpen(false);
      }
    });

    if (volChevron) {
      volChevron.addEventListener('click', function (e) {
        e.stopPropagation();
        if (usingEmbed) return;
        setVolPanelOpen(!volPanelOpen);
      });
    }

    if (volSlider) {
      volSlider.addEventListener('click', function (e) {
        e.stopPropagation();
      });
      volSlider.addEventListener('input', function (e) {
        e.stopPropagation();
        if (usingEmbed) return;
        var vol = parseFloat(volSlider.value);
        applyVolume(vol, { muteOnZero: true });
        if (vol > 0) {
          if (!root.classList.contains('eg-size-lg')) setVolPanelOpen(true);
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!root.classList.contains('eg-size-lg')) {
          setVolPanelOpen(false);
        }
      });
      volSlider.addEventListener('change', function (e) {
        e.stopPropagation();
      });
    }

    if (enlargeBtn) {
      enlargeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        cycleSize();
      });
    }

    minBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      minimize();
    });

    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      dismiss();
    });

    prevBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      loadIndex(index - 1);
    });

    nextBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      loadIndex(index + 1);
    });

    shell.addEventListener('click', function (e) {
      if (
        e.target.closest &&
        (e.target.closest('.eg-fr-btn') ||
          e.target.closest('.eg-fr-nav') ||
          e.target.closest('.eg-fr-cta') ||
          e.target.closest('.eg-fr-vol') ||
          e.target.closest('.eg-fr-vol-panel') ||
          e.target.closest('.eg-fr-vol-chevron') ||
          e.target.closest('.eg-fr-vol-wrap'))
      ) {
        return;
      }
      if (minimized) {
        restore();
        return;
      }
      if (usingEmbed) return;
      if (!c.clickToTogglePlay) return;
      if (video.paused) {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        video.pause();
      }
    });

    video.addEventListener('ended', function () {
      if (playlist.length > 1 && c.autoAdvance !== false) {
        loadIndex(index + 1);
      }
    });

    // Touch swipe for playlist
    var touchX = null;
    shell.addEventListener(
      'touchstart',
      function (e) {
        if (!e.touches || !e.touches.length) return;
        touchX = e.touches[0].clientX;
      },
      { passive: true }
    );
    shell.addEventListener(
      'touchend',
      function (e) {
        if (touchX == null || !e.changedTouches || !e.changedTouches.length) return;
        var dx = e.changedTouches[0].clientX - touchX;
        touchX = null;
        if (playlist.length < 2 || minimized) return;
        if (Math.abs(dx) < 40) return;
        if (dx < 0) loadIndex(index + 1);
        else loadIndex(index - 1);
      },
      { passive: true }
    );

    window.addEventListener('resize', applyLayout);

    // Public API
    window.EGFloatingReel = {
      minimize: minimize,
      restore: restore,
      close: dismiss,
      next: function () {
        loadIndex(index + 1);
      },
      prev: function () {
        loadIndex(index - 1);
      },
      cycleSize: cycleSize,
      reload: function () {
        var nc = cfg();
        Object.keys(nc).forEach(function (k) {
          c[k] = nc[k];
        });
        playlist = buildPlaylist(c);
        if (!playlist.length) {
          destroyWidget();
          return;
        }
        applyLayout();
        loadIndex(0);
      },
      destroy: destroyWidget,
      remount: remount,
      getConfig: cfg,
      el: root,
    };

    applyLayout();
    loadIndex(0);
    updateMuteIcon();
  }

  function boot() {
    var c = cfg();
    if (sessionClosed()) return;
    if (pathHidden(c)) return;

    function start(list) {
      if (!list || !list.length) {
        // Nothing to show — stay silent (editor can add videos later)
        return;
      }
      var delay = Math.max(0, c.delayMs || 0);
      setTimeout(function () {
        if (sessionClosed()) return;
        if (document.getElementById('eg-floating-reel')) return;
        createWidget(list, c);
      }, delay);
    }

    var local = buildPlaylist(c);
    if (local.length) {
      start(local);
      return;
    }

    // Optional Graph API playlist
    fetchGraphMedia(c, function (remote) {
      if (remote.length) start(remote);
      else start(local);
    });
  }

  // Always expose remount helpers for admin.html (even before first mount)
  window.EGFloatingReel = window.EGFloatingReel || {};
  window.EGFloatingReel.remount = remount;
  window.EGFloatingReel.destroy = destroyWidget;
  window.EGFloatingReel.getConfig = cfg;
  window.EGFloatingReel.STORAGE_CONFIG = STORAGE_CONFIG;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
